/* Vertastone project gallery data. One entry per job; photos in build order.
   img: file in assets/photos (an -800 version exists for every gal-* file).
   stage: shown as a chip in the viewer. cover: index of the card photo. */
window.VS_PROJECTS = [
  { id: 'training-grill', f: 'kitchen', type: 'Training build', t: 'Boulder grill island',
    c: 'Built from foam core to finished stone by the June training class in four days.',
    by: 'Vertastone training class', where: 'Montana', when: 'June 2026', cover: 4,
    photos: [
      ['photo-03-process-foam-carve.webp', 'Foam core', 'Foam core blocks cut and glued into a grill island shape on a patio'],
      ['real-base-coat.webp', 'Base coat', 'Instructor troweling Base Mix over mesh on the foam core'],
      ['real-carve-ledges.webp', 'Carving', 'Trowel cutting ledges into the fresh carve coat'],
      ['photo-02-hero-right.webp', 'Finished', 'Carved stone grill island with a stainless grill set into a boulder-shaped counter'],
      ['photo-01-hero-left.webp', 'Finished', 'Finished stained grill island with the grill installed'],
      ['photo-04-detail-grill-top.webp', 'Detail', 'Open stainless grill set into a carved, stained stone counter']
    ] },
  { id: 'pool-grotto', f: 'water', type: 'Pools & water features', t: 'Pool grotto with twin waterfalls',
    c: 'Carved rock wraps the pool, with two waterfalls and a stepping-stone ledge across the water.',
    by: 'Stone Crete Artisans', when: 'December 2023', cover: 0,
    photos: [
      ['gal-pool-grotto-1.webp', 'Finished', 'Carved rock grotto with twin waterfalls spilling into a turquoise pool'],
      ['gal-pool-grotto-2.webp', 'Finished', 'Pool edge of carved rock curving toward the waterfalls'],
      ['gal-pool-grotto-3.webp', 'Finished', 'Waterfalls over layered carved rock above clear pool water'],
      ['gal-pool-grotto-4.webp', 'Finished', 'Stepping-stone ledge crossing the pool below the grotto']
    ] },
  { id: 'backyard-falls', f: 'water', type: 'Water features', t: 'Backyard waterfall with lighting',
    c: 'A foam core carved into layered rock, stained in warm tones, then lit for evenings outside.',
    by: 'Stone Crete Artisans', when: 'March 2024', cover: 2,
    photos: [
      ['gal-backyard-falls-1.webp', 'Foam core', 'Foam blocks stacked and cut into the shape of a backyard waterfall'],
      ['gal-backyard-falls-2.webp', 'Carved, before color', 'Grey carved concrete waterfall before staining'],
      ['gal-backyard-falls-3.webp', 'Finished', 'Stained carved rock waterfall with water running over the ledges'],
      ['gal-backyard-falls-4.webp', 'Finished', 'Finished waterfall feature in a fenced backyard'],
      ['gal-backyard-falls-5.webp', 'Lit at night', 'The waterfall lit with warm and blue lights after dark'],
      ['gal-backyard-falls-6.webp', 'Lit at night', 'Blue underwater lighting glowing through the carved rock']
    ] },
  { id: 'night-grotto', f: 'water', type: 'Water features', t: 'Grotto waterfall and pond',
    c: 'A dug pond shell built up into a carved rock grotto, with lighting set into the ledges.',
    by: 'Stone Crete Artisans', when: 'August 2024', cover: 2,
    photos: [
      ['gal-night-grotto-1.webp', 'Pond shell', 'Concrete pond shell before the rockwork'],
      ['gal-night-grotto-2.webp', 'Carved, before color', 'Grey carved ledges around the pond under work lights'],
      ['gal-night-grotto-3.webp', 'Lit at night', 'Lit waterfall falling into the grotto pond at night'],
      ['gal-night-grotto-4.webp', 'Lit at night', 'Warm light glowing under the carved rock waterfall'],
      ['gal-night-grotto-5.webp', 'Finished', 'Wide view of the lit grotto waterfall and pond']
    ] },
  { id: 'boulder-falls', f: 'water', type: 'Water features', t: 'Boulder waterfall feature',
    c: 'Tall carved boulders and a stepped stream, built from foam up to finished, stained stone.',
    by: 'Stone Crete Artisans', when: 'June to July 2024', cover: 3,
    photos: [
      ['gal-boulder-falls-1.webp', 'Foam core', 'Foam blocks cut and stacked for a boulder waterfall'],
      ['gal-boulder-falls-2.webp', 'Foam core', 'Shaped foam forms for the stream and boulders'],
      ['gal-boulder-falls-3.webp', 'Carved, before color', 'Tall grey carved boulder with deep fissure lines'],
      ['gal-boulder-falls-4.webp', 'Finished', 'Stained carved boulders under a summer sky'],
      ['gal-boulder-falls-5.webp', 'Finished', 'Stepped carved stream between stained boulders'],
      ['gal-boulder-falls-6.webp', 'Finished', 'Carved rock outcrop with a ledge overhang'],
      ['gal-boulder-falls-7.webp', 'Detail', 'Close view of a stained carved boulder face']
    ] },
  { id: 'ledge-wall', f: 'wall', type: 'Retaining walls', t: 'Ledgestone retaining wall and stairs',
    c: 'A curved retaining wall and stair set carved to read like fitted fieldstone.',
    by: 'Stone Crete Artisans', when: 'July 2024', cover: 0,
    photos: [
      ['gal-ledge-wall-1.webp', 'Finished', 'Curved carved fieldstone retaining wall with stairs beside a driveway'],
      ['gal-ledge-wall-2.webp', 'Finished', 'Carved fieldstone wall wrapping a tree bed'],
      ['gal-ledge-wall-3.webp', 'Finished', 'Carved fieldstone pattern along the wall face'],
      ['gal-ledge-wall-4.webp', 'Detail', 'Close view of individually carved fieldstones']
    ] },
  { id: 'boulder-wall', f: 'wall', type: 'Garden walls', t: 'Carved boulder garden wall',
    c: 'Large carved slabs and boulders hold the bed and run along the walk.',
    by: 'Stone Crete Artisans', when: 'July 2024', cover: 0,
    photos: [
      ['gal-boulder-wall-1.webp', 'Finished', 'Carved boulder wall along a garden walk'],
      ['gal-boulder-wall-2.webp', 'Finished', 'Carved slab boulders holding a planted bed'],
      ['gal-boulder-wall-3.webp', 'Finished', 'Carved boulder wall stepping down beside the path']
    ] },
  { id: 'hillside-wall', f: 'wall', type: 'Retaining walls', t: 'Hillside ledge-rock wall',
    c: 'Holds back the slope and reads like a natural outcrop that was always there.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [
      ['app-wall.webp', 'Finished', 'Hillside retaining wall carved to look like a natural rock outcrop'],
      ['gal-hillside-wall-1.webp', 'Finished', 'Hillside retaining wall carved as a natural rock outcrop'],
      ['gal-hillside-wall-2.webp', 'Detail', 'Carved ledge lines across the hillside wall'],
      ['gal-hillside-wall-3.webp', 'Detail', 'Close view of carved rock fractures'],
      ['gal-hillside-wall-4.webp', 'Detail', 'Carved rock face with natural-looking layers']
    ] },
  { id: 'foundation-wall', f: 'wall', type: 'Stone facing', t: 'Stone-faced foundation and garage',
    c: 'Carved stone facing across the foundation and garage of a new home.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [
      ['gal-foundation-wall-1.webp', 'Finished', 'Carved stone facing across a garage and foundation'],
      ['gal-foundation-wall-2.webp', 'Finished', 'Stone-faced foundation along the side of a house'],
      ['gal-foundation-wall-3.webp', 'Finished', 'Carved stone facing below a balcony'],
      ['gal-foundation-wall-4.webp', 'Detail', 'Close view of carved stone facing beside a light']
    ] },
  { id: 'waterwheel-pond', f: 'water', type: 'Water features', t: 'Waterwheel pond and stream',
    c: 'A clear pond, carved rock banks and a working waterwheel beside the barn.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [
      ['gal-waterwheel-pond-1.webp', 'Finished', 'Pond with carved rock banks and a wooden waterwheel'],
      ['gal-waterwheel-pond-2.webp', 'Finished', 'Waterwheel and stone column above a carved rock stream'],
      ['gal-waterwheel-pond-3.webp', 'Finished', 'Pond and carved rock with mountains behind'],
      ['gal-waterwheel-pond-4.webp', 'Detail', 'Carved rock outcrop at the head of the stream']
    ] },
  { id: 'hillside-kitchen', f: 'kitchen', type: 'Outdoor kitchens', t: 'Hillside outdoor kitchen',
    c: 'Carved columns, seat walls and steps tie the kitchen into the hillside under the pergola.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [['app-kitchen.webp', 'Finished', 'Outdoor kitchen under a pergola with carved stone columns, walls and steps']] },
  { id: 'fire-bowl', f: 'fire', type: 'Fire features', t: 'Fire bowl surround',
    c: 'A boulder-style surround carved to hold a custom steel fire bowl.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [['app-fire.webp', 'Finished', 'Carved stone fire pit surround holding a steel fire bowl at sunset']] },
  { id: 'front-yard-wall', f: 'wall', type: 'Garden walls', t: 'Front yard garden wall',
    c: 'A low carved wall framing the front bed, with a tall boulder at the corner.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [['retaining-wall.webp', 'Finished', 'Low carved stone wall around a front yard garden bed']] },
  { id: 'indoor-stairs', f: 'steps', type: 'Interiors', t: 'Indoor carved rock staircase',
    c: 'A foam frame inside a new home, carved into a rock staircase rising to the loft.',
    by: 'Stone Crete Artisans', when: 'October 2023', cover: 3,
    photos: [
      ['gal-indoor-stairs-1.webp', 'Foam core', 'Foam blocks framing an indoor staircase'],
      ['gal-indoor-stairs-2.webp', 'Foam core', 'Foam shaped along the stair wall'],
      ['gal-indoor-stairs-3.webp', 'Carving in progress', 'Base coat and carving going onto the indoor rock'],
      ['gal-indoor-stairs-4.webp', 'Carving in progress', 'Carved rock staircase taking shape inside the house'],
      ['gal-indoor-stairs-5.webp', 'Carved', 'Carved rock staircase rising to the upper floor']
    ] },
  { id: 'cabin-bar', f: 'kitchen', type: 'Outdoor kitchens', t: 'Cabin outdoor bar',
    c: 'An outdoor bar on a log-cabin deck, built from shaped foam into carved stone.',
    by: 'Stone Crete Artisans', when: 'September 2023', cover: 2,
    photos: [
      ['gal-cabin-bar-1.webp', 'Foam core', 'Foam blocks stacked for an outdoor bar beside a log cabin'],
      ['gal-cabin-bar-2.webp', 'Foam core', 'Foam carved into the rough shape of the bar'],
      ['gal-cabin-bar-3.webp', 'Carved, before color', 'Grey carved stone outdoor bar on a deck'],
      ['gal-cabin-bar-4.webp', 'Carving in progress', 'Carving the bar under work lights at night']
    ] },
  { id: 'fire-patio', f: 'fire', type: 'Fire features', t: 'Fire pit patio',
    c: 'A fire pit circled by carved stone seating on a colored concrete patio.',
    by: 'Stone Crete Artisans', when: 'July 2024', cover: 0,
    photos: [
      ['gal-fire-patio-1.webp', 'Finished', 'Fire pit with carved stone seating on a patio among pines'],
      ['gal-fire-patio-2.webp', 'Finished', 'Carved stone benches around the fire bowl'],
      ['gal-fire-patio-3.webp', 'Finished', 'Carved slab bench beside the fire pit patio']
    ] },
  { id: 'fire-table', f: 'fire', type: 'Fire features', t: 'Carved fire table',
    c: 'A gas fire table carved to look like a single block of stone.',
    by: 'Stone Crete Artisans', when: 'November 2023', cover: 0,
    photos: [
      ['gal-fire-table-1.webp', 'Finished', 'Carved stone fire table with a fire glass burner'],
      ['gal-fire-table-2.webp', 'Finished', 'Carved fire table set into a gravel yard']
    ] },
  { id: 'entry-steps', f: 'steps', type: 'Steps & entries', t: 'Front entry steps',
    c: 'Carved slab steps and planter walls at the front door.',
    by: 'Stone Crete Artisans', when: 'September 2023', cover: 0,
    photos: [
      ['gal-entry-steps-1.webp', 'Finished', 'Carved stone entry steps with planters at a front door'],
      ['gal-entry-steps-2.webp', 'Finished', 'Carved slab treads leading to the front porch']
    ] },
  { id: 'stone-stairs', f: 'steps', type: 'Steps & entries', t: 'Carved slab entry stairs',
    c: 'Carved slab treads that look like quarried stone.',
    by: 'Stone Crete Artisans', cover: 0,
    photos: [
      ['gal-stone-stairs-1.webp', 'Finished', 'Carved stone slab stairs leading up to a front entry'],
      ['gal-stone-stairs-2.webp', 'Finished', 'Carved slab stairs curving through a planted bed']
    ] },
  { id: 'tub-surround', f: 'interior', type: 'Interiors', t: 'Carved stone tub surround',
    c: 'A bathroom wrapped in carved, stained stone around the soaking tub.',
    by: 'Stone Crete Artisans', when: 'July 2021', cover: 0,
    photos: [
      ['gal-tub-surround-1.webp', 'Finished', 'Bathroom tub surrounded by carved, stained stone walls'],
      ['gal-tub-surround-2.webp', 'Finished', 'Carved stone shower wall above the tub'],
      ['gal-tub-surround-3.webp', 'Finished', 'Corner of the carved stone tub surround']
    ] }
];
